<mims-overlay [visible]="enableBackDrop && showOverlay"></mims-overlay>
<div #loaderContainer class="loader-container">
  <div #iconContainer class="icon-container">
    <img alt="loader-image" [src]="imgPath" />
  </div>
  <div class="spinner"></div>
</div>
<p *ngIf="text">{{ text }}</p>
